// @flow
import { Component } from 'react';
import { replaceUrlTo } from '../../../utils/url';

type Props = {};

export class RedirectToRecover extends Component<Props> {
	componentDidMount() {
		replaceUrlTo(`${process.env.REACT_APP_ABSPATH || '/'}activate`);
	}

	render() {
		return null;
	}
}

export default RedirectToRecover;


// WEBPACK FOOTER //
// ./src/components/utils/RedirectToRecover/index.js